import {
  Emphases,
  LabelIds,
  Perspectives,
  RowColors,
  RowIds,
  SectionIds,
} from "../consts";
import { defineRows } from "../defineRows";
import { collectedFoodDrinkCaption } from "./labelRules";

/**
 * Host UK FSV PAV “Collected at venue” block (inbox sidebar second section).
 */
const collectedAtVenueRows = defineRows(SectionIds.CollectedAtVenue, {
  collectedAtVenue: [
    {
      id: RowIds.CollectedFoodDrinkMinimum,
      amount: (facts) => facts.foodDrinkMinimum,
      perspective: Perspectives.Host,
      label: () => ({ id: LabelIds.FoodDrinkMinimum }),
      caption: (facts) => collectedFoodDrinkCaption(facts),
      allowZero: true,
    },
    {
      id: RowIds.CollectedAddOnsTotal,
      amount: (facts) => facts.collectedAtVenueAddOns,
      perspective: Perspectives.Host,
      label: () => ({ id: LabelIds.CollectedAddOnsTotal }),
    },
    {
      id: RowIds.CollectedGuestSpendAtVenue,
      amount: (facts) => facts.dueAtVenue,
      perspective: Perspectives.Host,
      label: () => ({ id: LabelIds.GuestSpendAtVenue }),
      emphasis: Emphases.Strong,
      color: RowColors.Highlight,
      show: (facts) => facts.dueAtVenue != null && facts.dueAtVenue > 0,
    },
  ],
});

export { collectedAtVenueRows };
